import { srSubstitute } from 'platform/forms-system/src/js/utilities/ui/mask-string';
import { replaceStrValues } from 'platform/shared/health-apps';

// declare previous year for form questions and content
export const LAST_YEAR = new Date().getFullYear() - 1;
export const strWithYear = str => replaceStrValues(str, LAST_YEAR);

/**
 * Helper that maps an array to an object literal to allow for multiple keys to
 * have the same value
 * @param {Array} arrayToMap - an array of arrays that defines the keys/values to map
 * @returns {Object} - an object literal
 */
export const createLiteralMap = arrayToMap =>
  Object.fromEntries(
    arrayToMap.flatMap(([value, keys]) => keys.map(key => [key, value])),
  );

/**
 * Helper that visually-masks the Veteran's Social Security number and separates
 * each number so screenreaders will read "ending with 1 2 3 4" instead of
 * "ending with 1,234"
 * @param {String} value - the Social Security number string from the form data
 * @returns {Element} - React element containing the masked string and
 * screenreader-compatible output
 */
export const maskSSN = (value = '') => {
  if (!value) return srSubstitute('', 'is blank');
  const number = value.slice(-4);
  return srSubstitute(
    `●●●–●●–${number}`,
    `ending with ${[...number].join(' ')}`,
  );
};
